import React from 'react';
import css from './Link.css';
import { SFEntityID } from 'utils/types';

export default class ChangeAppointmentLink extends React.Component {

  render() {
    return <a href={`../instructor/upcoming.html#/appointment/${this.props.appointmentId}`}
              className={css['link']}>
      Make a change to this appointment
    </a>;
  }
}

ChangeAppointmentLink.propTypes = {
  appointmentId: SFEntityID.isRequired
};
